import { createRouter, createWebHashHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import VentasView from '../views/Reportes/VentasView.vue'
import VentasPlacaView from '../views/Reportes/VentasPlacaView.vue'
import VentasHoraView from '../views/Reportes/VentasPorHoraView.vue'
import VentasCanastillaView from '../views/Reportes/VentasCanastillaView.vue'


import FElectronicaView from '../views/ReporteFacturas/FElectronicaView.vue'
import VentasGeneralView from '../views/ReporteGeneral/ReporteVentaGeneralView.vue'


import FElectronicaViewGNV from '../views/Reportes/FElectronicaViewGNV.vue'
import NClectronicaView from '../views/Reportes/FENotasCreditosView.vue'

import VentasConciliadasView from '../views/Reportes/VentasConciliadasView.vue'
import ClientesView from '../views/Clientes/ClientesView.vue'
import RecargasView from '../views/Clientes/RecargasView.vue'
import ExtractoCuentasView from '../views/Clientes/ExtractoCuentasView.vue'
import FlotasView from '../views/Vehiculos/FlotasView.vue'
import VehiculosView from '../views/Vehiculos/VehiculosView.vue'
import ConversionesView from '../views/Vehiculos/ConversionesView.vue'
import CorteDiarioView from '../views/Reportes/CorteDiarioView.vue'
import TurnosView from '../views/Reportes/TurnosView.vue'

import FacturadorView from '../views/Facturador/FacturadorView.vue'
import FacturadorColombiaView from '../views/Facturador/FacturadorColombiaView.vue'
import FacturadorFillPosView from '../views/Facturador/FacturadorFillPOSView.vue'


import DescuentoView from '../views/Descuentos/DescuentoView.vue'
import RecaudoView from '../views/Financieras/RecaudoView.vue'
import EntidadesAcuerdosView from '../views/Financieras/EntidadesAcuerdosView.vue'
import ReporteRecaudosView from '../views/Financieras/ReporteRecaudosView.vue'
import GestionUsuariosView from '../views/Personas/GestionUsuariosView.vue'
import ImportadorView from '@/views/Vehiculos/ImportadorView.vue'

import ParametrosView from '../views/Parametros/ParametrosView.vue'
import ParametrosColombia from '../views/Parametros/ParametrosColombia.vue'

import ClientePrecioView from '@/views/Clientes/ClientePrecioView.vue'
import GLOBAL from '@/Global'

const ParametrosEmpresaComponent =
  GLOBAL.COUNTRY === 'CO' ? ParametrosColombia : ParametrosView

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/reportes/ventas',
    name: 'reportes-ventas',
    component: VentasView,
  },
  {
    path: '/reportes/ventas_placa',
    name: 'reportes-ventas-placa',
    component: VentasPlacaView,
  },
  {
    path: '/reportes/ventas_horas',
    name: 'reportes-ventas-horas',
    component: VentasHoraView,
  },
  {
    path: '/reportes/ventas_documento',
    name: 'reportes-ventas-documento',
    component: VentasCanastillaView,
  },
  {
    path: '/reportes/felectronica',
    name: 'reportes-felectronica',
    component: FElectronicaView,
  },
  {
    path: '/reportes/ventas_general',
    name: 'reportes-ventas-general',
    component: VentasGeneralView,
  },
  {
    path: '/reportes/felectronica-gnv',
    name: 'reportes-felectronica-gnv',
    component: FElectronicaViewGNV,
  },
  {
    path: '/reportes/ncelectronica',
    name: 'reportes-ncelectronica',
    component: NClectronicaView,
  },
  {
    path: '/reportes/conciliaciones',
    name: 'reportes-conciliaciones',
    component: VentasConciliadasView,
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: ClientesView,
  },
  {
    path: '/recargas',
    name: 'recargas',
    component: RecargasView,
  },
  {
    path: '/extracto',
    name: 'extracto',
    component: ExtractoCuentasView,
  },
  {
    path: '/clientes/despachos',
    name: 'despachos',
    component: FacturadorColombiaView,
  },
  {
    path: '/flotas',
    name: 'flotas',
    component: FlotasView,
  },
  {
    path: '/reportes/corte',
    name: 'corte',
    component: CorteDiarioView,
  },
  {
    path: '/reportes/turnos',
    name: 'turnos',
    component: TurnosView,
  },
  {
    path: '/facturador/facturador/:uuid?',
    name: 'facturador',
    component: FacturadorView,
  },
  {
    path: '/facturador/facturadorPOS',
    name: 'facturadorPOS',
    component: FacturadorFillPosView,
  },
  {
    path: '/descuentos',
    name: 'descuentos',
    component: DescuentoView,
  },
  {
    path: '/vehiculos',
    name: 'vehiculos',
    component: VehiculosView,
  },
  {
    path: '/importador',
    name: 'importador',
    component: ImportadorView,
  },
  {
    path: '/conversiones',
    name: 'conversiones',
    component: ConversionesView,
  },
  {
    path: '/recaudos',
    name: 'recaudos',
    component: RecaudoView,
  },
  {
    path: '/entidades-acuerdos',
    name: 'entidades-acuerdos',
    component: EntidadesAcuerdosView,
  },
  {
    path: '/reporte-recaudos',
    name: 'reporte-recaudos',
    component: ReporteRecaudosView,
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: GestionUsuariosView,
  },
  {
    path: '/parametros-empresa',
    name: 'parametros-empresa',
    component: ParametrosEmpresaComponent,
  },
  {
    path: '/cliente-precio',
    name: 'cliente-precio',
    component: ClientePrecioView,
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === "home") {
    const user = JSON.parse(sessionStorage.getItem("kubber.persona"));
    const perfilUsuario = parseInt(atob(user.perfil_id));

    let componenteHome = HomeView;

    switch (perfilUsuario) {
      case 8:
        componenteHome = FacturadorFillPosView;
        break;
      case 5:
        componenteHome = VehiculosView;
        break;
      case 6:
        componenteHome = RecaudoView;
        break;
    }

    to.matched[0].components.default = componenteHome;
  }

  next();
});

export default router